import image11 from './11.svg';
import image22 from './22.svg';
import image33 from './33.svg';
import image44 from './44.svg';
import image55 from './55.svg';
import image66 from './66.svg';
import image77 from './77.svg';
import image88 from './88.svg';
import image99 from './99.svg';
import image10 from './10.svg';
import image111 from './111.svg';
import image12 from './12.svg';

const ImageAbout = {
    image11,
    image22,
    image33,
    image44,
    image55,
    image66,
    image77,
    image88,
    image99,
    image10,
    image111,
    image12,
};

export default ImageAbout;